<template>
<div>
                <div class="text-center mb-20 glot-text-color-EB font-hairline">
                 <span class="text-center" v-html="$t('RegisterTitle')"></span>
                  <b v-for="(name, index) in nameDomain" :key="name">
                    {{name}}
                    <b v-if="index < nameDomain.length - 1">{{$t('and')}}</b>
                  </b>
                </div>
                
                <div class="">
                 <div  @click="clickSignUpOTher('Facebook')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                   <img class="inline-block mr-2" src="@/assets/images/icons/facebookIcon.png"/>
                   <a @keyup.enter.prevent="clickSignUpOTher('Facebook')" tabindex="0" class="glot-text-color-3B glot-text-font-size-16 font-bold">{{$t('FacebookSignUp')}}</a>
                   </div>
                 <div class="w-4"/>
                 <div @click="clickSignUpOTher('Google')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                   <img src="@/assets/images/svg/icons/googleIcon.svg" class="mr-2"/>
                   <a @keyup.enter.prevent="clickSignUpOTher('Google')" tabindex="0" class="glot-text-color-51 glot-text-font-size-16 font-bold">{{$t('GoogleSignUp')}}</a>
                 </div> 
                 <div @click="clickSignUpOTher('Apple')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                   <img src="@/assets/images/icons/appleIcon.png" class="mr-2"/>
                   <a tabindex="0" @keyup.enter.prevent="clickSignUpOTher('Apple')" class="glot-text-color-2C glot-text-font-size-16 font-bold">{{$t('AppleSignUp')}}</a>
                 </div>
                </div>
                <div class="mb-2">
                  <vs-divider color="#EBEEFD" class="opacity-50" ><span class="uppercase glot-text-color-EB opacity-50">{{$t('Or')}}</span></vs-divider>
                  <p class="text-center glot-text-color-EB">{{$t('SignUpWithEmail')}}</p>
                </div>
              <form
                @submit.prevent="validForm('registerForm')"
                data-vv-scope="registerForm"
                >
                  <!-- <vs-input
                    v-validate="'required|min:3|max:20|nameContain|No_Start|No_End|No__Inside'"
                    data-vv-validate-on="input"
                    name="name"
                    icon-no-border
                    :label-placeholder="$t('YourName')"
                    v-model="name"
                    class="w-full"/>
                    <div class="text-danger text-sm mb-6">{{ errors.first('registerForm.name') }}</div> -->

                   <vs-input
                    v-validate="'required|glot_email'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    :label-placeholder="$t('YourEmail')"
                    v-model="email"
                    class="w-full"/>
                    <div class="text-danger text-sm mb-6">{{ errors.first('registerForm.emailRes') }}</div>

                  <!-- <div class="relative">
                    <vs-input
                    data-vv-validate-on="input"
                    v-validate="'required|min:6'"
                    :type="passwordType"
                    name="password"
                    icon-no-border
                    :label-placeholder="$t('YourPassWord')"
                    v-model="password"
                    class="w-full mb-1" />
                    <span class="absolute m-auto top-0 bottom-0 right-0 mr-1 flex items-center cursor-pointer" >
                    <feather-icon :icon="[passwordIcon]" @click="hidePassword = !hidePassword" svgClasses="h-4 w-4 stroke-current text-grey absolute m-auto top-0 bottom-0 right-0 mr-1" class="block" />
                    </span>
                   </div> -->
                    <div class="text-danger text-sm">{{ errors.first('registerForm.password') }}</div>
                    <input class="opacity-0 absolute" type="submit"/>
            
              </form>
                
                <div class="mt-10">
                  <vs-button  class="w-full glot-background-color-1D uppercase" @click="clickSignUp">{{$t('SignMeUp')}}</vs-button>
                </div>
          </div>
</template>

<script>

import {CONNECT_FACEBOOK, CONNECT_GOOGLE} from '@/config/commonConfig'

import _throttle from 'lodash/throttle'

import {getErrorMessage} from '@/i18n/util'

import {getMainDomain} from '@/utils/getMainDomain'
const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export default {
  components: {
  },
  props:{
    nameDomain: String
  },
  data () {
    return {
      email: '',
      password: '',
      name:'',
      hidePassword: true,
      clientId: process.env.VUE_APP_CLIENT_ID,
      scope: process.env.VUE_APP_SCOPE,
      redirectURI: getMainDomain(process.env.VUE_APP_REDIRECT_URL),
      state: process.env.VUE_APP_STATE,
      usePopup: process.env.VUE_APP_USE_POPUP,
      nonce: process.env.VUE_APP_NONE
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== '' && this.name !== ''
    },
    passwordType () {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon () {
      return this.hidePassword ? 'EyeIcon' : 'EyeOffIcon'
    }
  },
  methods: {
    err (msg) {
      if (typeof console !== 'undefined') {
        console.error(`[vue-apple-signin] ${msg}`)
      }
    },
    clickSignUpOTher (type) {
      if (type === 'Facebook') {
        window.location.href = CONNECT_FACEBOOK
      }
      if (type === 'Google') {
        window.location.href = CONNECT_GOOGLE
      }
      if (type === 'Apple') {
        this.$vs.loading({
          background: 'rgba(0, 0, 0, 0.6)'
        })
        window.AppleID.auth.signIn().then((response) => {
          this.$vs.loading.close()
          const {authorization: {id_token}} = response
          this.$router.push(`/auth/apple/callback?access_token=${id_token}`)
        }).catch((err) => {
          this.$vs.loading.close()
          const { message } = err
          if (message) {
            this.$vs.notify({
              title: 'Error',
              text:  message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
      }
    },
    clickSignUp () {
      if (!this.checkLogin()) return
        
      const isEmail = emailRegExp.test(this.email)

      if (isEmail) {
        this.email = this.email.toLowerCase()
      } else {
        this.errors.add({
          field: 'email',
          msg: 'Email invalid',
          scope:'registerForm'
        })
        this.$vs.notify({
          title: 'Register Attempt',
          text: 'Please provide valid email',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      }

      const [name, tails] = this.email.split('@')
      if (name.includes('+')) {
        if (tails !== 'ejoylearning.com') {
          this.errors.add({
            field: 'email',
            msg: 'Email invalid',
            scope:'registerForm'
          })
          this.$vs.notify({
            title: 'Register Attempt',
            text: 'Please provide valid email (email contains wrongs character)',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          return 
        }
      }

      this.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })
      const payload = {
        email: this.email
      }
      

      this.$store.dispatch('auth/signupWithEmail', payload).then(res => {
        this.$vs.loading.close()
        this.$router.push('/sent-email-register')
      }).catch(err => {
        this.$vs.loading.close()
        err.messages.map(e => {
          console.log(e)
          let type = 'name'
          if (e.id === 'Auth.form.error.email.taken') {
            type = 'emailRes'
          }
          this.errors.add({
            field: type,
            msg: getErrorMessage([e]),
            scope:'registerForm'
          })
        })
        this.$vs.notify({
          title: 'Register Attempt',
          text: getErrorMessage(err.messages),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    validForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.clickSignUp(this);
        }
      })
    },
    checkLogin () {
      // If user is already logged in notify
      return true
    },
    registerUserJWt () {
      // If form is not validated or user is already login return
      if (!this.validateForm || !this.checkLogin()) return

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          password: this.password,
          confirmPassword: this.confirm_password
        },
        notify: this.$vs.notify
      }
      this.$store.dispatch('auth/registerUserJWT', payload)
    },
    callOnSuccess () {
    },
    callOnFailure () {
    }
  },
  beforeDestroy () {
    const self = this
    document.removeEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.removeEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  },
  mounted () {
    if (!window.AppleID) {
      this.err('"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" needs to be included as a <script>')
      return
    }
    const clientId = this.clientId
    const scope = this.scope
    const redirectURI = this.redirectURI
    const state = this.state
    const nonce = this.nonce
    const usePopup = this.usePopup === 'true'

    if (!clientId) {
      this.err('options.clientId must be specified.')
      return
    }

    if (!redirectURI) {
      this.err('options.redirectURI must be specified.')
      return
    }

    if (!state) {
      this.err('options.state must be specified.')
      return
    }

    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup,
      nonce
    })
    const self = this
    document.addEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.addEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
